// const HOST_ROOT = 'https://lbank.ma'; // http://localhost // https://lbank.ma
const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
  lbanka: '/',
};

// ----------------------------------------------------------------------

export const paths = {
  // DASHBOARD
  lbanka: {
    root: ROOTS.lbanka,
    roles: `/roles`,
    accounts: `/accounts`,
    new_account: `/new-account`,
    checkbooks: `/checkbooks`,
    issued_checks: `/issued-checks`,
    recieved_checks: `/recieved-checks`,
    calendar: `/calendar`,
    partners: `/partners`,
    profile: `/profile`,
    transfers: `/transfers`,
    local_beneficiaries: `/locals`,
    foreign_beneficiaries: `/foreigns`,
    projects: `/projects`,
    guarantees: `/guarantees`,
    files: `/files`,
    chat: `/chat`,
    // Parameters
    user: (id: string) => `/user/${id}`,
    account: (id: string) => `/account/${id}`,
    rib: (id: string) => `/rib/${id}`,
    carnet: (id: string) => `/checkbook/${id}`,
    check: (id: string) => `/issued-check/${id}`,
    received_check: (id: string) => `/received-check/${id}`,
    // External
    upgrade: '/pricing',
  },
  
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  minimalUI: 'https://lbanka.com',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/login`,
      register: `${ROOTS.AUTH}/register`,
      forgotPassword: `${ROOTS.AUTH}/forgot-password`,
      newPassword: `${ROOTS.AUTH}/new-password`,
      verify: `${ROOTS.AUTH}/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD
  },
};
